module.exports = __webpack_public_path__ + "img/home@2x.016a4a9b.jpg";